import React, { useEffect, useState } from 'react';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import { PrimaryButton } from '../components/button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';

export default function SumSubRegister() {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [url, setUrl] = useState('');
  const [allow, setAllow] = useState('');
  const [showproceedButton, setshowproceedButton] = useState(false);
  const [intervalCall, setintervalCall] = useState(false);
  const [data, setData] = useState();
  const [shownameinput, setShownameinput] = useState(false);
  const [fullname, setFullname] = useState('');
  const [loading, setLoading] = useState(false);
  const registration_type = sessionStorage.getItem('registrationType');
  console.log('Registration type', registration_type);
  console.log(url);
  console.log(data);
  const getData = async () => {
    const uniqueId = location.state?.phone ||sessionStorage.getItem('login_phone');
    const encryptedPayload = await encryptPayload({
                "user_id": uniqueId,
                "platform": 'web',
                "extraParamValidation": 'trustedfromweb'
            });
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-187-SUMSUB-URL',
        encryptedPayload,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY } },
      )
      .then((resp) => {
        setUrl(resp.data.url);
        setAllow('camera ' + resp.data.url + '; microphone ' + resp.data.url);
      })
      .catch((err) => {
        toast.error(err.response.data);
      });

    setintervalCall(
      setInterval(function () {
        checkuserregisteredstatus();
      },10000),
    );
  };

  const checkuserregisteredstatus = async () => {
    const uniqueId =  location.state?.phone || sessionStorage.getItem('login_phone');
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-188-SUMSUB-DETAILS',
        { user_id: uniqueId },
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY } },
      )
      .then((resp) => {
        if (resp.data) {
          setshowproceedButton(true);
          setData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const proceedtoScreen = async (firstname, lastname,kycLater = false) => {
    const registrationType = sessionStorage.getItem('registrationType');
    const token = sessionStorage.getItem('registrationToken');
    var deviceId = sessionStorage.getItem('deviceid');
    var userid = sessionStorage.getItem('userid');

    setLoading(true);
    const encryptedPayload = await encryptPayload({
         firstName: firstname || data.firstNameEn,
          lastName: lastname || data.lastNameEn,
          dob: data.dob,
          country: (data.country || '').slice(0, 2),
          address: data.addresses?.[0].formattedAddress,
          street: data.addresses?.[0].street,
          town: data.addresses?.[0].town,
          postCode: data.addresses?.[0].postCode,
          platform: "web",
          extraParamValidation: "trustedfromweb"
        });
    axios
      .post(
        Constants.BASE_URL + 'API-FX-186-UPDATE-USER-DETAILS',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + token,
          },
        },
      )
      .then(async() => {
        const dropencryptedPayload = await encryptPayload({
              screen_name: 'DOB_ADDRESS_5',
              meta: {
                 regType: registrationType === "individual" ? "personal" : registrationType,
                 kyc_status:kycLater?'Later':'Completed'
                },
              device_id: deviceId,
              user_id: userid,
            });
        axios
          .post(
            Constants.BASE_URL + 'API-FX-159-DROPSCREEN',
            dropencryptedPayload,
            { headers: { fx_key: Constants.SUBSCRIPTION_KEY } },
          )
          .then(() => {
            clearInterval(intervalCall);
            setLoading(false);
              sessionStorage.setItem('kyc_pending_later', kycLater ? 'true' : 'false');
            if (
              registrationType === 'personal' ||
              registrationType === 'individual'
            ) {
              navigate('/Welcome');
            } else navigate('/BusinessDetails', { state: { pin: null } });
          })
          .catch((dropError) => {
            setLoading(false);
            toast.error(dropError.response.data.message);
          });
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <ToastContainer />

      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8">
        {/* Logo */}
        <div className="mb-6 flex justify-center">
          <img src="fx_logo_old.png" alt="Logo" className="w-24" />
        </div>

        <h1 className="text-2xl font-bold mb-6 text-center uppercase">
          Verify KYC
        </h1>

        {/* If iframe not loaded, show message  */}
        {!url ? (
          <div className="flex items-center justify-center w-full h-64">
            <p className="text-lg text-gray-600 font-medium">
              Loading KYC Verification...
            </p>
          </div>
        ) : (
          <iframe
            src={url}
            allow={allow}
            className="w-full h-96 border rounded-lg"
            title="KYC Verification"
          ></iframe>
        )}
        {registration_type == 'individual' && !showproceedButton && (
          <div className="w-full mt-6">
            <PrimaryButton
              loading={loading}
              label="Do KYC Later"
              onClick={() => setShownameinput(true)}
              style={{ width: '100%' }}
            />
          </div>
        )}
        {shownameinput && (
          <div className="w-full mt-4 flex justify-between items-center">
            <input
              type="text"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              placeholder="Enter Full Name"
              className="w-[70%] border rounded-lg px-4 py-2"
            />

            <div className="w-[25%]">
              <PrimaryButton
                label="Continue"
                loading={loading}
                onClick={() => {
                  const parts = fullname.trim().split(/\s+/);

                  if (parts.length !== 2) {
                    toast.error('Please enter your Full Name');
                    return;
                  }
                  proceedtoScreen(parts[0], parts[1],true);
                  setFullname('')
                }}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        )}
        <div className="w-full mt-6">
          {showproceedButton && !shownameinput && (
            <PrimaryButton
              loading={loading}
              label={'KYC Verified. Please Click Here to Proceed'}
              onClick={() =>{
                proceedtoScreen(undefined,undefined,false)
              }}
              style={{ width: '100%' }}
            />
          )}
        </div>
      </div>
    </div>
  );
}